<template>
 <v-container fluid>
      <v-flex xs12>
      <v-tabs dark background-color="blue" v-model="active" slider-color="white">
          <v-tab ripple router exact  :to="`/parcelnumbercontainers/${$route.params.id}/tabs/container`">Container</v-tab>
          <v-tab ripple router exact  :to="`/parcelnumbercontainers/${$route.params.id}/tabs/parcelnumberranges`">Number Ranges</v-tab>
          <v-tab ripple router exact  :to="`/parcelnumbercontainers/${$route.params.id}/tabs/parcelnumberportals`">Portals</v-tab>
      </v-tabs>
    </v-flex>
    <router-view></router-view>

	</v-container>

</template>



<script>
  export default {
    data() {
      return {
        active: null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// GetParcelNumberContainerTabs.vue?4d9388e8